module.exports = __webpack_public_path__ + "static/media/hand-scissors.8b5f6a8d.svg";